import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ReplacementListInfo } from '../vo/replacement-list-info.model';

// レスポンス構造
export interface GetReplacementGoodsResponse {
  FeatureCode: string;
  FeatureName: string;
  ClassCode: string;
  ClassName: string;
  MiddleClassCode: string;
  MiddleClassName: string;
  StockNum: string;
  PCode: string;
  ItemCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  PricePattern: string;
  ThisTimeSupplyPrice: string;
  ThisTimeCostPrice: string;
  PredictPlanNum: string;
  PlanNum: string;
  PlanSupplyBudget: string;
  TagName: string;
  Remarks: string;
  SelectorType: string;
  BuyerRequestId: string;
}

/**
 * 代替商品情報取得サービス
 * @export GetReplacementGoodsService
 * @class GetReplacementGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetReplacementGoodsService extends PlessJsonResponderSub<GetReplacementGoodsResponse> {
  model: KYMW7001Model;
  selectItem: ReplacementListInfo;
  private calbak: (data: GetReplacementGoodsResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetReplacementGoodsService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      ReplacementList: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode,
          PCode: this.selectItem.pCode,
          ItemCode: this.selectItem.itemCode,
        },
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetReplacementGoodsService
   */
  execute(model: KYMW7001Model, selectItem: ReplacementListInfo, f?: (data: GetReplacementGoodsResponse) => void): void {
    this.model = model;
    this.selectItem = selectItem;
    if (f) this.calbak = f;
    this.send('getReplacementGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetReplacementGoodsService
   */
  success(data: GetReplacementGoodsResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
